import { round } from '../utils/number'

export function calculateRatePerMile(rate: number, mileage: number) {
  return round(rate / mileage, 3)
}

export function calculateFlatRate(rate: number, mileage: number) {
  return round(rate * mileage, 2)
}
